import { render, staticRenderFns } from "./CadastroPerfil.vue?vue&type=template&id=794c991e"
import script from "./CadastroPerfil.vue?vue&type=script&lang=js"
export * from "./CadastroPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports